<template>
  <Layout>
    <router-view />
  </Layout>
  <Notification ref="notification" />
</template>

<script>
import '@/assets/fonts/inter/inter.css'
import '@/assets/icons/phosphor/styles.min.css'
import '@/assets/template/css/all.min.css'
import '@/assets/fonts/made-tommy/made-tommy.css'
import '@/assets/css/style.css'
import '@/assets/template/js/app'
import '@/assets/template/js/configuration'
import Layout from '@/views/layout/Layout.vue'
import Notification from '@/components/commons/Notification.vue'

export default {
  name: 'App',

  components: {
    Layout,
    Notification,
  },
}
</script>
